/** "Loading Operations…" from `/operations/...` or legacy `/hospitality/...` (second segment). */
export const DEFAULT_LOADER_MESSAGE = 'Loading…';

const SEGMENT_LOADER_LABELS: Record<string, string> = {
  form: 'Form',
  addH: 'Organization setup',
  forgot: 'Password reset',
  register: 'Registration',
  operations: 'Operations',
  rooms: 'Room setup',
  logs: 'Logs',
  audits: 'Activity logs',
  reporting: 'Reporting',
  compliance: 'Compliance',
  metrics: 'Metrics',
  departments: 'Departments',
  settings: 'Settings',
  customers: 'Guests',
  'walk-ins': 'Walk-ins',
  recipients: 'Recipients',
  reservations: 'Reservations',
  setup: 'Asset setup',
  'back-office': 'Back office',
  'reporting-analytics': 'Back office',
  // Legacy operations-module URL prefix → same loader as Operations.
  hospitality: 'Operations',
  'sales-distribution': 'Sales',
};

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const HEX_TOKEN_RE = /^[A-Fa-f0-9]{24,}$/;

/** URL segment that is a record id, invite token, or similar — not a page slug. */
const looksLikeOpaqueId = (segment: string): boolean => (
  UUID_RE.test(segment)
  || HEX_TOKEN_RE.test(segment)
  || /^\d+$/.test(segment)
);

const titleCaseSegment = (segment: string): string => {
  try {
    const decoded = decodeURIComponent(segment);
    return decoded.charAt(0).toUpperCase() + decoded.slice(1);
  } catch {
    return segment.charAt(0).toUpperCase() + segment.slice(1);
  }
};

const loaderMessageForSegment = (segment: string): string => {
  const mapped = SEGMENT_LOADER_LABELS[segment];
  if (mapped) return `Loading ${mapped}…`;
  return `Loading ${titleCaseSegment(segment)}…`;
};

export const getRouteLoadingMessage = (pathname: string) => {
  const parts = pathname.split('/').filter(Boolean);
  if ((parts[0] === 'back-office' || parts[0] === 'reporting-analytics') && parts[1] === 'records') {
    return 'Loading Master data…';
  }
  if ((parts[0] === 'back-office' || parts[0] === 'reporting-analytics') && parts[1] === 'command-center') {
    return 'Loading Command center…';
  }
  if ((parts[0] === 'back-office' || parts[0] === 'reporting-analytics') && parts[1] === 'departments') {
    return 'Loading Departments…';
  }
  if (parts[0] === 'sales-distribution' && parts[1] === 'departments') {
    return 'Loading Import…';
  }
  const segment = parts[1] || parts[0];
  if (!segment) return DEFAULT_LOADER_MESSAGE;

  if (looksLikeOpaqueId(segment)) {
    const parent = parts.length >= 2 ? parts[0] : null;
    if (parent) {
      return loaderMessageForSegment(parent);
    }
    return DEFAULT_LOADER_MESSAGE;
  }

  return loaderMessageForSegment(segment);
};
